import { QUERY } from './apollo'
const LS_PREFIX = '--pxnmsc'
const ACCESS_TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const USER_KEY = 'usr'
const USER_ATTRS_KEY = 'usr_attrs'

function setItem(suffix, value) {
  localStorage.setItem(`${LS_PREFIX}_${suffix}`, value)
}

function getItem(suffix) {
  return localStorage.getItem(`${LS_PREFIX}_${suffix}`)
}

function removeItem(suffix) {
  localStorage.removeItem(`${LS_PREFIX}_${suffix}`)
}

/**
 * Set
 */

export function setLocalTokens(accessTokenValue, refreshTokenValue) {
  setItem(ACCESS_TOKEN_KEY, accessTokenValue)
  setItem(REFRESH_TOKEN_KEY, refreshTokenValue)
}

export function setLocalValues({ accessToken, refreshToken, user, userAttrs }) {
  if (accessToken) {
    setLocalTokens(accessToken, refreshToken)
  }
  if (user) {
    setItem(USER_KEY, user)
  }
  if (userAttrs) {
    setItem(USER_ATTRS_KEY, userAttrs)
  }
}

/**
 * Get
 */

export function getLocalTokens() {
  return [getItem(ACCESS_TOKEN_KEY), getItem(REFRESH_TOKEN_KEY)]
}

export function getLocalUser() {
  return getItem(USER_KEY)
}

export function getLocalUserAttrs() {
  return getItem(USER_ATTRS_KEY)
}

/**
 * Remove
 */

export function removeAllItems() {
  removeItem(ACCESS_TOKEN_KEY)
  removeItem(REFRESH_TOKEN_KEY)
  removeItem(USER_KEY)
  removeItem(USER_ATTRS_KEY)
}

/**
 * Responses
 */

export function loggedInResponse(
  cache,
  { accessToken, refreshToken, user, ...attrs }
) {
  setLocalValues({
    accessToken,
    refreshToken,
    user: JSON.stringify(user),
    userAttrs: JSON.stringify(attrs),
  })

  return cache.writeQuery({
    query: QUERY.IS_LOGGED_IN,
    data: {
      loggedIn: true,
      userInfo: user,
      ...attrs,
    },
  })
}

export async function loggedOutResponse(client) {
  removeAllItems()
  return await client.resetStore()
}
